export enum WorkflowActionTypes {
    SendMail = 1,
    SendSms = 2,
    UpdateAttribute = 3,
    ChangeStepState = 4,
    ActivateStep = 5,
    SwitchFolderAsUnread = 6,
    OpenUrl = 7,
    ApiCall = 8,
    CompleteStep = 9,
    CompleteWorkflow = 10,
    TimerStop = 11,
    ReminderCreation = 12,
    ArchiveFolder = 13,
}
